/** #################################### Generated content ####################################
 * This block has been generated with deppy create-index (for more information https://github.com/webedx-spark/deppy)
 **/

export { StaffManagementStoreV2 } from './src/store';
export { default as StaffPermissionsLink } from './src/StaffPermissionsLink';
export { default as WithUserRoleModal } from './src/StaffPermissions/components/WithUserRoleModal';
export {
  getCourseStaffManagementScopeData,
  trackStaffManagementPageViewEvent,
} from './src/StaffPermissions/utils/eventingUtils';
export { isUoL, isSessionStaffVisibleForPartner } from './src/utils/sessionStaffUtils';
export { default as SessionStaffManager } from './src/sessionStaffManager';
export { default as InstitutionStaff } from './src/InstitutionStaff';
export { default as StaffManagementCDS } from './src/cds/StaffManagement';
export { redesignStaffManagement } from './src/utils/epic';
/**
 *  #################################### Generated content ####################################
 **/
